import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { Shipment } from '../../../domain/model/shipment/Shipment.types';
import type { RootState } from '../../../configuration/setup/store';
import type { Packaging } from '../../../domain/model/packaging/Packaging.types';
import type { AvailableAction } from '../../../domain/model/available-actions/AvailableActions.types';

export type ShipmentToTransfer = {
    shipment: Shipment;
    packaging?: Packaging;
    transferAction: AvailableAction;
};

export type ShipmentTransferOptionsState = {
    showShipmentTransferOptions: boolean;
    shipmentsToTransfer: ShipmentToTransfer[];
    confirmationSubmitted: boolean;
};

const initialState: ShipmentTransferOptionsState = {
    showShipmentTransferOptions: false,
    shipmentsToTransfer: [],
    confirmationSubmitted: false,
};

export const shipmentTransferOptionsSlice = createSlice({
    name: 'shipmentTransferOptions',
    initialState,
    reducers: {
        setShipmentsToTransfer: (state, action: PayloadAction<ShipmentToTransfer[]>) => {
            state.shipmentsToTransfer = action.payload;
        },
        setShowDialog: (state, action: PayloadAction<boolean>) => {
            state.showShipmentTransferOptions = action.payload;
        },
        resetAndCloseDialog: state => {
            state.showShipmentTransferOptions = false;
            state.shipmentsToTransfer = [];
        },
        setConfirmationSubmitted: (state, action: PayloadAction<boolean>) => {
            state.confirmationSubmitted = action.payload;
        },
    },
});

export const shipmentTransferOptionsActions = shipmentTransferOptionsSlice.actions;

export const getShipmentsToTransfer = (state: RootState) =>
    state[shipmentTransferOptionsSlice.reducerPath].shipmentsToTransfer;

export const getShowShipmentTransferOptions = (state: RootState) =>
    state[shipmentTransferOptionsSlice.reducerPath].showShipmentTransferOptions;

export const getConfirmationSubmitted = (state: RootState) =>
    state[shipmentTransferOptionsSlice.reducerPath].confirmationSubmitted;
